<div class="container">
    <h2>{{'Please select a region' | translate}}</h2>
    <div class="custom-control text-center">
        <label>{{'Select your country/region' | translate}}</label>
        <select class="select custom-select col-3" [(ngModel)]="country" (ngModelChange)="changeCountry()">
            <option *ngFor="let country of countries" [value]="country.code">{{country.name}}</option>
        </select>
    </div>
</div>

<div class="container text-center fullEmpty" *ngIf="fullEmpty">

    <p *ngIf="!isIndustrial && !isService">
        {{'Currently, we do not have an Official Zortrax Reseller in the selected region. Check our offer in the online store.' | translate}}
    </p>
    <p *ngIf="!isIndustrial && isService  && !isApoller">
        {{'Currently, we do not have an Official Zortrax Service Center in the selected region. To contact with our service fill the form.' | translate}}
    </p>
    <p *ngIf="!isIndustrial && isService && isApoller">
        {{'Any malfunctions of the Zortrax Apoller device must be reported directly to Zortrax. In order to contact our service team, fill in the form.'| translate}}
    </p>
    <p *ngIf="isIndustrial && isService">
        {{'Currently, we do not have an Zortrax Authorised Service for Industrial Series Products in the selected region. In order to contact our service team, fill in the form.'| translate}}
    </p>
    <p *ngIf="isIndustrial && !isService">
        {{'Currently, we do not have an Official Zortrax Industrial Distributor in the selected region. Check our offer in the online store.'| translate}}
    </p>

    <a *ngIf="!isService" class="btn btn-primary"
       href="https://store.zortrax.com">{{'Go to Zortrax online store' | translate}}</a>
    <a *ngIf="isService" class="btn btn-primary"
       href="https://support.zortrax.com/support-form/">{{'Go to Zortrax Support Form' | translate}}</a>
</div>
<div class="container my-2 text-center" *ngIf="isService && !fullEmpty">
    <h5>{{'Service of Zortrax devices for the selected region is provided by:'|translate}}</h5>
</div>
<div class="container-fluid p-0" *ngIf="!fullEmpty">

    <agm-map style="height: 600px" [scrollwheel]="false" [fitBounds]="true" [maxZoom]="15"
             (mapReady)="mapReady($event)"
             [styles]="mapStyle">
        <agm-marker-cluster [averageCenter]="true"
                            [imagePath]="imgUrl + 'm'">
            <agm-marker [latitude]="+reseller.lat" [longitude]="+reseller.lon" [agmFitBounds]="true"
                        *ngFor="let reseller of filteredResellersList">
                <agm-info-window [maxWidth]="700">
                    <app-reseller [reseller]="reseller"></app-reseller>
                </agm-info-window>
            </agm-marker>

        </agm-marker-cluster>
    </agm-map>
</div>

<div class="featured" *ngIf="featured.length">
    <div class="container">
        <h5>{{'Featured Partners' | translate}}
            <img [popper]="popper1Content"
                 [popperShowOnStart]="false"
                 [popperTrigger]="'hover'"
                 [popperHideOnClickOutside]="true"
                 [popperHideOnScroll]="true"
                 [src]="imgUrl + 'svg/question.svg'"
                 [popperPlacement]="'right'"
                 [popperStyles]="{backgroundColor: '#ffffff',boxShadow: '0 0.5rem 1rem 0 rgba(44,51,73,.1)', border: '1px solid #dededf', color: '#333333'}"
                 class="info"/>
        </h5>
        <popper-content #popper1Content>
            <span>{{'Partners Recommended by Zortrax' | translate}}</span>
        </popper-content>
        <div class="resellerList distributor d-flex flex-wrap">
            <app-reseller *ngFor="let reseller of featured " [reseller]="reseller"
                          class="col-12 col-md-6 col-lg-4 col-xl-4 d-flex flex-column onList"></app-reseller>
        </div>
    </div>
</div>


<div class="distributor section" *ngIf="distributor.length">
    <div class="container">
        <h5>{{'Official Distributor' | translate}}
            <img [popper]="popper2Content"
                 [popperShowOnStart]="false"
                 [popperTrigger]="'hover'"
                 [popperHideOnClickOutside]="true"
                 [popperHideOnScroll]="true"
                 [src]="imgUrl + 'svg/question.svg'"
                 [popperPlacement]="'right'"
                 [popperStyles]="{backgroundColor: '#ffffff',boxShadow: '0 0.5rem 1rem 0 rgba(44,51,73,.1)', border: '1px solid #dededf', color: '#333333'}"
                 class="info"/>
        </h5>
        <popper-content #popper2Content>
            <span *ngIf="!isIndustrial">{{'Distributors who run service of Zortrax devices' | translate}}</span>
            <span *ngIf="isIndustrial">{{'Distributors who run service of Zortrax industrial devices' | translate}}</span>
        </popper-content>
        <div class="resellerList distributor d-flex flex-wrap">
            <app-reseller *ngFor="let reseller of distributor " [reseller]="reseller"
                          class="col-12 col-md-6 col-lg-4 col-xl-4 d-flex flex-column onList"></app-reseller>
        </div>
    </div>
</div>
<div class="resellersWithService section" *ngIf="resellersWithService.length">


    <div class="container">
        <h5>{{'Resellers with service points' | translate}}
            <img [popper]="popper3Content"
                 [popperShowOnStart]="false"
                 [popperTrigger]="'hover'"
                 [popperHideOnClickOutside]="true"
                 [popperHideOnScroll]="true"
                 [src]="imgUrl + 'svg/question.svg'"
                 [popperPlacement]="'right'"
                 [popperStyles]="{backgroundColor: '#ffffff',boxShadow: '0 0.5rem 1rem 0 rgba(44,51,73,.1)', border: '1px solid #dededf', color: '#333333'}"
                 class="info"/>
        </h5>
        <popper-content #popper3Content>
            <span>{{'Resellers who run service of Zortrax devices' | translate}}</span>
        </popper-content>
        <div class="resellerList distributor d-flex flex-wrap">
            <app-reseller *ngFor="let reseller of resellersWithService " [reseller]="reseller"
                          class="col-12 col-md-6 col-lg-4 col-xl-4 d-flex flex-column onList"></app-reseller>
        </div>
    </div>
</div>
<div class="resellers section" *ngIf="resellers.length">
    <div class="container">
        <h5>{{'Resellers' | translate}}
            <img [popper]="popper4Content"
                 [popperShowOnStart]="false"
                 [popperTrigger]="'hover'"
                 [popperHideOnClickOutside]="true"
                 [popperHideOnScroll]="true"
                 [src]="imgUrl + 'svg/question.svg'"
                 [popperPlacement]="'right'"
                 [popperStyles]="{backgroundColor: '#ffffff',boxShadow: '0 0.5rem 1rem 0 rgba(44,51,73,.1)', border: '1px solid #dededf', color: '#333333'}"
                 class="info"/>
        </h5>
        <popper-content #popper4Content>
            <span>{{'Resellers without service of Zortrax devices' | translate}}</span>
        </popper-content>
        <div class="resellerList distributor d-flex flex-wrap">
            <app-reseller *ngFor="let reseller of resellers " [reseller]="reseller"
                          class="col-12 col-md-6 col-lg-4 col-xl-4 d-flex flex-column onList"></app-reseller>
        </div>
    </div>
</div>

<div class="container">

    <div class="jumper text-left" (click)="prevStep()">
        <img class="mr-1" [src]="imgUrl + 'svg/back_arrow.svg'"/>{{'Previous Step' | translate}}
    </div>

</div>
